webpackJsonp([1],{

/***/ "03nL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Education_vue__ = __webpack_require__("TCT9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9191e350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Education_vue__ = __webpack_require__("IsoX");
function injectStyle (ssrContext) {
  __webpack_require__("xBbf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Education_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9191e350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Education_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3/ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"persistent":"","light":"","overflow":"","permanent":""}},[_c('v-card',{staticClass:"drawer__card",attrs:{"elevation-1":""}},[_c('v-avatar',{staticClass:"drawer__card--avatar"},[_c('img',{attrs:{"src":__webpack_require__("yu07")}})]),_vm._v(" "),_c('span',{staticClass:"drawer__card--name"},[_vm._v("\n      "+_vm._s(_vm.fullName)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"drawer__card--title"},[_vm._v("\n      "+_vm._s(_vm.jobTitle)+"\n    ")])],1),_vm._v(" "),_c('v-list',{staticClass:"drawer__nav-list",attrs:{"two-line":""}},[_vm._l((_vm.navList),function(nav,index){return [_c('v-list-tile',{key:("list-tile-" + index),class:_vm.active === index ? 'active' : '',attrs:{"avatar":"","ripple":""},on:{"click":function($event){$event.stopPropagation();_vm.navigate(nav.path)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"drawer__nav-list--title"},[_c('i',{class:nav.class},[_vm._v(_vm._s(nav.icon))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(nav.title))])])],1)],1),_vm._v(" "),_c('v-divider',{key:("divider-" + index)})]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "48k/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headline: 'Projects',
      projects: [{
        expanded: true,
        title: 'Leads generation funnel',
        subTitle: 'A web-based funnel that converts traffic from ads to subscribers & leads',
        featureHeader: 'Modules/Pieces',
        features: ['Landing/static pages - Tilda', 'Collect survey - Typeform', 'Collect user data - Mixpanel', 'Booking platform - Bookeo', 'Email campaigns - Mailchimp', 'Allows platforms to communicate - Communications/Integrations Module', 'import data from mixpanel->DB, Mailchimp->Mixpanel, etc. - Data exporter module', 'Great display about campaigns, funnels, reports, etc. -> Metabase', 'Manage lead allocation - schedule & allocate to Partners - Job processing module']
      }, {
        expanded: false,
        title: 'Event Bot',
        subTitle: 'Bot running on telegram & facebook messenger to manage events',
        featureHeader: 'Modules',
        features: ['App interacting with messenger clients w/session management - Facebook module', 'App interacting with telegram clients w/session management - Telegram module', 'Data layer module built w/ an upfront REST API - Python Eve', 'Handle ticket checkout funnel & payment(Paypal) - Payment module', 'Admin panel to manage events/bots/messages/etc - AOR(v1), react-boilerplate fork(v2)']
      }, {
        expanded: false,
        title: 'E-commerce for Travel Insurance',
        subTitle: 'Web platform for indonesia that provides the company the ability to sell insurance online.',
        featureHeader: 'Modules',
        features: ['Frontend module', 'Orchestration Module', 'Order Module', 'Payment Module', 'Job Queuing Module', 'Quotation Module']
      }, {
        expanded: false,
        title: 'Chat Platform',
        subTitle: 'A platform that lets users from across the globe communicate with specific people through SMS, email, & partner applications using a web platform.',
        featureHeader: 'Features',
        features: ['Report generation', 'Auto reply, Auto ban, Auto filter(inbound & outbound rules)', 'admin interfaces ', 'message mapping & queueing systems', 'monitoring systems with alert mechanism using SMS & Email.']
      }, {
        expanded: false,
        title: 'Online Enrollment System',
        subTitle: 'A web application that enables students to search and apply for courses in certain across the globe.',
        featureHeader: 'Modules',
        features: ['Video Interview', 'Search and compare courses', 'Online Application']
      }, {
        expanded: false,
        title: 'Robotics Controller',
        subTitle: 'A bundled nodejs application that feeds instructions to UiPath(Robotics).',
        featureHeader: 'What it does',
        features: ['Retrieves data & instructions from a queue', 'Parses instructions & feeds it to UiPath Robot API', 'Monitors UiPath Job and send update to queue', 'Auto upate itself']
      }, {
        expanded: false,
        title: 'Campaign Manager',
        subTitle: 'A web application that is used to manage campaigns and has a rest API to allow the ecommerce-platform to consume data.',
        featureHeader: 'Modules',
        features: ['Manage campaigns(CRUD)', 'Manage rules inside a campaign', 'Manage promo codes', 'REST API to consume campaign benefits']
      }, {
        expanded: false,
        title: 'Life Insurance Product Quotation Module',
        subTitle: 'A module that allows users to get a quote and send leads to salesforce.',
        featureHeader: 'What it does',
        features: ['Gather customer info', 'Generate quote', 'Send customer data to salesforce']
      }]
    };
  }
});

/***/ }),

/***/ "6tLp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7qBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headLine: 'You may reach me by any of these means',
      contacts: [{
        type: 'E-mail',
        value: 'theodoro.pelingan@gmail.com',
        class: 'material-icons icon green--text text--darken-2 icon--large',
        icon: 'email',
        href: 'mailto:theodoro.pelingan@gmail.com'
      }, {
        type: 'Linkedin',
        value: 'https://www.linkedin.com/in/theodoro-pelingan-jr',
        class: 'material-icons icon blue--text text--darken-2 icon--large',
        icon: 'link',
        href: 'https://www.linkedin.com/in/theodoro-pelingan-jr'
      }, {
        type: 'Call or SMS',
        value: '+63906 5784 859',
        class: 'material-icons icon red--text text--darken-2 icon--large',
        icon: 'call',
        href: 'tel:+639065784859'
      }, {
        type: 'Skype',
        value: 'theodoro.pelingan.jr',
        class: 'material-icons icon yellow--text text--darken-2 icon--large',
        icon: 'contacts',
        href: 'callto:theodoro.pelingan.jr'
      }]
    };
  }
});

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Z18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TechnicalExperience_vue__ = __webpack_require__("48k/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_614b989c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TechnicalExperience_vue__ = __webpack_require__("FV6b");
function injectStyle (ssrContext) {
  __webpack_require__("8ybK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TechnicalExperience_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_614b989c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TechnicalExperience_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8s5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"employment"},[_c('v-expansion-panel',{attrs:{"popout":"","focusable":""}},_vm._l((_vm.jobs),function(job,index){return _c('v-expansion-panel-content',{key:index,staticClass:"details__container",attrs:{"expand":""},model:{value:(job.expanded),callback:function ($$v) {_vm.$set(job, "expanded", $$v)},expression:"job.expanded"}},[_c('div',{staticClass:"headline details__header--job-title",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(job.title))]),_vm._v(" "),_c('div',{staticClass:"details__header"},[_c('div',{staticClass:"subheading"},[_c('span',{staticClass:"details__header--company-name"},[_vm._v(_vm._s(job.company.name))]),_vm._v(" "),_c('span',{staticClass:"details__header--company-stay"},[_vm._v(_vm._s(job.company.stay))])]),_vm._v(" "),_c('div',{staticClass:"subheading details__header--company-location"},[_vm._v(_vm._s(job.company.location))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',{staticClass:"title details__task--header"},[_vm._v(_vm._s(job.taskHeader))]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((job.tasks),function(task,index){return [_c('v-list-tile',{key:index},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(task)}})],1)],1)]})],2)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8ybK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AElC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      readOnly: true,
      increment: 0.5,
      languages: {
        native: {
          list: [{ name: 'Javascript', rating: 4.5 }, { name: 'HTML/HTML5', rating: 4.5 }, { name: 'CSS/CSS3', rating: 4 }, { name: 'PHP', rating: 4 }, { name: 'Java', rating: 3.5 }],
          headline: 'Native'
        },
        javascript: {
          list: [{ name: 'jQuery', rating: 4.5 }, { name: 'NodeJS', rating: 4.5 }, { name: 'ExpressJS', rating: 4.5 }, { name: 'React w/Redux', rating: 4 }, { name: 'Angular 1 w/ MD', rating: 4 }, { name: 'Vue w/Vuex & Vuetify', rating: 4 }, { name: 'SocketIO', rating: 4 }, { name: 'Mocha, Chai, Sinon, Supertest', rating: 4 }, { name: 'ES6,7', rating: 4 }, { name: 'Grunt/Gulp/Webpack', rating: 4 }, { name: 'Istanbul', rating: 4 }, { name: 'Sequelize/Mongoose', rating: 4 }, { name: 'npm/yarn/bower', rating: 4 }, { name: 'babel', rating: 4 }, { name: 'Nightwatch/Enzyme', rating: 3.5 }, { name: 'WebRTC', rating: 3.5 }],
          headline: 'Javascript'
        },
        php: {
          list: [{ name: 'Laravel 5', rating: 4 }, { name: 'CI 2,3', rating: 4 }, { name: 'Eloquent, Doctrine', rating: 4 }, { name: 'Composer', rating: 4 }],
          headline: 'PHP Tech'
        },
        css: {
          list: [{ name: 'Bootstrap', rating: 4 }, { name: 'Material', rating: 4 }, { name: 'Vuetify', rating: 4 }, { name: 'SCSS', rating: 4 }],
          headline: 'CSS Tech'
        },
        database: {
          list: [{ name: 'MySQL/MariaDB/SQL Server', rating: 4 }, { name: 'PostgreSQL', rating: 4 }, { name: 'MongoDB', rating: 4 }, { name: 'Redis', rating: 4 }],
          headline: 'Database'
        },
        others: {
          list: [{ name: 'GIT/SVN', rating: 4.5 }, { name: 'docker/compose/swarm', rating: 4.5 }, { name: 'AWS - EC2, Lambda, Cloudwatch, cloudfront, SNS, Route53, S3, etc.', rating: 4 }, { name: 'TravisCI/CircleCI/Jenkins/BB Pipelines', rating: 4 }, { name: 'CodeClimate/SonarQube', rating: 4 }, { name: 'OpenShift', rating: 4 }, { name: 'Kong/AWS API Gateway', rating: 3.5 }, { name: 'Bash', rating: 3.5 }, { name: 'New Relic', rating: 3.5 }, { name: 'Kubernetes', rating: 3.5 }, { name: 'GCP w/Codefresh', rating: 3.5 }, { name: 'ELK Stack', rating: 3.5 }, { name: 'stefanprodan/dockprom Stack', rating: 3.5 }, { name: 'GraphQL', rating: 3.5 }],
          headline: 'Dev/Ops & stuff'
        }
      }
    };
  }
});

/***/ }),

/***/ "Acnb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageAndTech_vue__ = __webpack_require__("AElC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42159a56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageAndTech_vue__ = __webpack_require__("Entz");
function injectStyle (ssrContext) {
  __webpack_require__("cXKU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageAndTech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42159a56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageAndTech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CHZF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cjmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"about-me",attrs:{"fluid":""}},[_c('v-flex',{staticClass:"headline about-me__headline"},[_vm._v(_vm._s(_vm.headLine))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{staticClass:"aboutme__details"},_vm._l((_vm.aboutMeList),function(me,index){return _c('v-container',{key:index},[_c('v-container',{key:("title-" + index),staticClass:"title"},[_vm._v(_vm._s(me.title))]),_vm._v(" "),_c('v-container',{key:("subheading-" + index),staticClass:"subheading"},[_c('a',{attrs:{"href":me.content,"target":"_blank"}},[_vm._v(_vm._s(me.content))])]),_vm._v(" "),_c('v-divider',{key:index})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EL+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      name: {
        first: 'Theodoro',
        middleInitial: 'S.',
        last: 'Pelingan',
        suffix: 'Jr.'
      },
      jobTitle: 'Fullstack Web Developer'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['navList', 'currentNav']), {
    fullName: function fullName() {
      return this.name.first + ' ' + this.name.middleInitial + ' ' + this.name.last + ' ' + this.name.suffix;
    },
    active: function active() {
      return this.navList.indexOf(this.currentNav);
    }
  }),
  methods: {
    navigate: function navigate(path) {
      this.$router.replace(path);
    }
  }
});

/***/ }),

/***/ "Entz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"lang-tech",attrs:{"fluid":""}},_vm._l((_vm.languages),function(category,index){return _c('v-flex',{key:index},[_c('v-container',{staticClass:"headline lang-tech__headline"},[_vm._v(_vm._s(category.headline))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_vm._l((category.list),function(lang,index){return [_c('v-list-tile',{key:index},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"title",domProps:{"textContent":_vm._s(lang.name)}})],1),_vm._v(" "),_c('star-rating',{attrs:{"rating":lang.rating,"read-only":_vm.readOnly,"increment":_vm.increment,"text-class":"star-rating__text"}})],1)]})],2)],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FV6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"tech-exp"},[_c('v-container',{staticClass:"headline tech-exp__headline"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-expansion-panel',{attrs:{"popout":"","focusable":""}},_vm._l((_vm.projects),function(project,index){return _c('v-expansion-panel-content',{key:index,staticClass:"details__container",attrs:{"expand":""},model:{value:(project.expanded),callback:function ($$v) {_vm.$set(project, "expanded", $$v)},expression:"project.expanded"}},[_c('div',{staticClass:"title details__header--job-title",attrs:{"slot":"header"},slot:"header"},[_vm._v(" "+_vm._s(project.title)+" ")]),_vm._v(" "),_c('div',{staticClass:"subheading tech-exp__sub-heading"},[_vm._v(_vm._s(project.subTitle))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',{staticClass:"body-2 details__task--header"},[_vm._v(_vm._s(project.featureHeader))]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((project.features),function(feature,index){return [_c('v-list-tile',{key:index},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(feature)}})],1)],1)]})],2)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HBni":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      accounts: [{
        name: 'linkedin',
        class: 'blue--text links__container--linkedin',
        link: 'https://www.linkedin.com/in/theodoro-pelingan-jr'
      }, {
        name: 'stackoverflow',
        class: 'yellow--text links__container--stackoverflow',
        link: 'https://stackoverflow.com/users/4772229/theo'
      }, {
        name: 'github',
        class: 'green--text links__container--github',
        link: 'https://github.com/shierro'
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getToolbarTitle']))
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_content_Education__ = __webpack_require__("03nL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_content_Employment__ = __webpack_require__("k45l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_content_TechnicalExperience__ = __webpack_require__("8Z18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_content_LanguageAndTech__ = __webpack_require__("Acnb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_content_Contact__ = __webpack_require__("KY2+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_content_AboutMe__ = __webpack_require__("MupS");











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  state: {
    routeList: [{
      path: '/',
      name: 'Main',
      redirect: '/employment'
    }, {
      title: 'Employment',
      icon: 'assignment',
      class: 'material-icons icon green--text text--darken-2 icon--large',
      path: '/employment',
      name: 'Employment'
    }, {
      title: 'Technical Experience',
      icon: 'business',
      class: 'material-icons icon yellow--text text--darken-2 icon--large',
      path: '/technical-experience',
      name: 'TechnicalExperience'
    }, {
      title: 'Language and Technologies',
      icon: 'code',
      class: 'material-icons icon red--text text--darken-2 icon--large',
      path: '/language-and-tech',
      name: 'LanguageAndTech'
    }, {
      title: 'Education',
      icon: 'school',
      class: 'material-icons icon blue--text text--darken-2 icon--large',
      path: '/education',
      name: 'Education'
    }, {
      title: 'Contact',
      icon: 'call',
      class: 'material-icons icon orange--text text--darken-2 icon--large',
      path: '/contact',
      name: 'Contact'
    }, {
      title: 'About Me',
      icon: 'person',
      class: 'material-icons icon deep-purple--text text--darken-2 icon--large',
      path: '/about-me',
      name: 'AboutMe'
    }],
    components: {
      Employment: __WEBPACK_IMPORTED_MODULE_4__components_content_Employment__["a" /* default */],
      TechnicalExperience: __WEBPACK_IMPORTED_MODULE_5__components_content_TechnicalExperience__["a" /* default */],
      LanguageAndTech: __WEBPACK_IMPORTED_MODULE_6__components_content_LanguageAndTech__["a" /* default */],
      Education: __WEBPACK_IMPORTED_MODULE_3__components_content_Education__["a" /* default */],
      Contact: __WEBPACK_IMPORTED_MODULE_7__components_content_Contact__["a" /* default */],
      AboutMe: __WEBPACK_IMPORTED_MODULE_8__components_content_AboutMe__["a" /* default */]
    }
  },
  strict: debug
}));

/***/ }),

/***/ "IsoX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"educ",attrs:{"fluid":""}},[_c('v-container',{staticClass:"educ_header"},[_c('v-flex',{staticClass:"headline educ__headline"},[_vm._v(_vm._s(_vm.headLine))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{staticClass:"educ_body"},[_c('v-flex',{staticClass:"title educ__body--school__name"},[_vm._v(_vm._s(_vm.school.name))]),_vm._v(" "),_c('v-flex',{staticClass:"sub-heading educ__body--school__address"},[_vm._v(_vm._s(_vm.school.address))]),_vm._v(" "),_c('v-flex',{staticClass:"sub-heading educ__body--duration"},[_vm._v(_vm._s(_vm.duration))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KY2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("7qBg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0abebcbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("mZzP");
function injectStyle (ssrContext) {
  __webpack_require__("ziSZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0abebcbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6475f720_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("lpb8");
function injectStyle (ssrContext) {
  __webpack_require__("6tLp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6475f720_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MupS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__ = __webpack_require__("rt52");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47990286_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMe_vue__ = __webpack_require__("Cjmh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47990286_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('star-rating', __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "SczH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__ = __webpack_require__("EL+O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b11eb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__ = __webpack_require__("3/ks");
function injectStyle (ssrContext) {
  __webpack_require__("fES6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b11eb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TCT9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headLine: 'Bachelor of Science in Information Technology',
      school: {
        name: 'Saint Louis University',
        address: 'Baguio City, Philippines'
      },
      duration: '2009 to 2014'
    };
  }
});

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0b832a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("lNaI");
function injectStyle (ssrContext) {
  __webpack_require__("aDxI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0b832a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UDck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monthDiff; });
var monthDiff = function monthDiff(start, end) {
  var tempDate = new Date(start);
  var monthCount = 0;
  while (tempDate.getMonth() + '' + tempDate.getFullYear() !== end.getMonth() + '' + end.getFullYear()) {
    monthCount++;
    tempDate.setMonth(tempDate.getMonth() + 1);
  }
  return monthCount + 1;
};

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  currentNav: function currentNav(state, getters) {
    return getters.navList.find(function (element) {
      return element.path === state.route.path;
    });
  },
  navList: function navList(state) {
    return state.routeList.filter(function (nav) {
      return nav.redirect === undefined;
    });
  },
  routeList: function routeList(state) {
    var routeList = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.routeList));
    routeList.forEach(function (route, index) {
      route.component = state.components[route.name];
    });
    return routeList;
  },
  getToolbarTitle: function getToolbarTitle(state, getters) {
    return getters.currentNav.title;
  }
});

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      credits: '© 2017-2018'
    };
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.routeList
}));

/***/ }),

/***/ "aDxI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cXKU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fES6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k45l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Employment_vue__ = __webpack_require__("kF03");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c933b67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Employment_vue__ = __webpack_require__("8s5e");
function injectStyle (ssrContext) {
  __webpack_require__("CHZF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Employment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c933b67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Employment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kF03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dateUtil__ = __webpack_require__("UDck");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var latestStartDate = new Date(2017, 11, 20);
var today = new Date();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      jobs: [{
        title: 'Fullstack Developer / DevOps',
        company: {
          name: 'ClinkIT Solutions / RareBirds',
          stay: 'November 2017 - Present (' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dateUtil__["a" /* monthDiff */])(latestStartDate, today) + ' mos)',
          location: 'Remote'
        },
        taskHeader: 'Responsibilities:',
        tasks: ['Create micro services(lambda or ec2) - following TDD', 'Create SPA(react-boilerplate fork) apps based on zeplin mockups', 'Create a chatbot on facebook & telegram', 'App integrations - XERO, Tilda, Mixpanel, Typeform, bookeo, Mailchimp, Facebook API, Telegram API, Paypal, Salesforce, etc.', 'RND - Reporting & communication platforms', 'Backlog management using JIRA. Convert CEO/CIO/PO requirements to technical solutions & chunked tasks', 'Semi-gitflow pattern. Release management w/ semantic versioning', 'Set-up & utilize AWS technologies - [EC2, SNS, Cloudfront, Cloudwatch, Lambda, RDS, etc]', 'Work remotely with different folks(Austraian, Russian, Filipino, Indonesian) on different timezones'],
        expanded: true
      }, {
        title: 'Fullstack Web Developer',
        company: {
          name: 'VISEO',
          stay: 'April 2017 - December 2017 (8 mos)',
          location: 'Makati, PH'
        },
        taskHeader: 'Responsibilities:',
        tasks: ['Perform Scrum techniques', 'Create micro services', 'Follow TDD', 'Utilize a CI/CD pipeline - Jenkins, OpenShift, Sonarqube', 'Project management through JIRA', 'Create SPA(React w/Redux) from scratch', 'Create css using SASS', 'Create Unit & e2e Tests', 'Use git for source code control', 'Maintain & update legacy systems'],
        expanded: false
      }, {
        title: 'Software Engineer 2',
        company: {
          name: 'Twistresources',
          stay: 'September 2016 – April 2017 (8 mos)',
          location: 'Angeles City, Pampanga, PH'
        },
        taskHeader: 'Responsibilities:',
        tasks: ['Follow SCRUM techniques', 'Build and deploy applications to multiple environments utilizing Docker', 'Manage code quality through code reviews', 'Research and development - Video conferencing', 'Project management using Redmine', 'Follow Git workflow', 'Create workflow automations(testing, deployment)', 'Optimize website performance', 'Convert mock-ups to usable AngularJS components'],
        expanded: false
      }, {
        title: 'Web Developer',
        company: {
          name: 'Rossking Pty. Ltd.',
          stay: 'Mar 2015 – Sep 2016 (1yr 7mos)',
          location: 'Baguio City, PH'
        },
        taskHeader: 'Responsibilities:',
        tasks: ['Legacy website Maintenance/enhancement', '3rd party platform integrations', 'RDBMS Schema modeling / optimization', 'Connecting, documenting & managing Restful APIs', 'Building websites from scratch', 'Creating a realtime chat platform'],
        expanded: false
      }]
    };
  }
});

/***/ }),

/***/ "lNaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"indigo links__container"},[_c('span',{staticClass:"white--text credits__text hidden-sm-and-down"},[_vm._v(_vm._s(_vm.credits))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lpb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app","toolbar":"","footer":""}},[_c('drawer'),_vm._v(" "),_c('main-header'),_vm._v(" "),_c('main',[_c('v-slide-x-reverse-transition',[_c('router-view')],1)],1),_vm._v(" "),_c('main-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mZzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"contact",attrs:{"fluid":""}},[_c('v-flex',{staticClass:"headline educ__headline"},[_vm._v(_vm._s(_vm.headLine))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.contacts),function(contact){return [_c('v-list-tile',{key:contact.type,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('i',{class:contact.class},[_vm._v(_vm._s(contact.icon))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"educ__list--contact"},[_c('v-list-tile-title',{staticClass:"educ__list--contact__type",domProps:{"innerHTML":_vm._s(contact.type)}}),_vm._v(" "),_c('v-list-tile-sub-title',[_c('a',{attrs:{"href":contact.href,"target":"__blank"}},[_vm._v(_vm._s(contact.value))])])],1)],1)]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rt52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headLine: 'Personal Stuff',
      aboutMeList: [{
        title: 'Semi-Professional Gamer',
        content: 'https://steamcommunity.com/profiles/76561198155982984/'
      }, {
        title: 'PLUM Profile',
        content: 'https://app.plum.io/profile/theodoropelinganjr'
      }]
    };
  }
});

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62cfabf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("zfr1");
function injectStyle (ssrContext) {
  __webpack_require__("HBni")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62cfabf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xBbf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Drawer__ = __webpack_require__("SczH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__("teIl");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    mainFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Drawer: __WEBPACK_IMPORTED_MODULE_0__components_Drawer__["a" /* default */],
    MainHeader: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */]
  }
});

/***/ }),

/***/ "yu07":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/picture.44dcec6.jpg";

/***/ }),

/***/ "zfr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"indigo",attrs:{"dark":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"hidden-sm-and-down display-1"},[_vm._v("\n    "+_vm._s(_vm.getToolbarTitle)+"\n  ")]),_vm._v(" "),_c('v-flex',{staticClass:"links__container text-xs-right"},_vm._l((_vm.accounts),function(account,index){return _c('v-btn',{key:index,class:account.class,attrs:{"icon":"","alt":account.name,"title":account.name,"href":account.link,"target":"__blank"}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ziSZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.952313115df69f1d9386.js